import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import ManufacturabilityScore from "./ManufacturabilityScore";
import IndustrialMetrics from "./IndustrialMetrics";
import SuggestedMachine from "./SuggestedMachine";

export function ScoreTab({ a }) {
  return (
    <div className="space-y-5" data-testid="score-tab">
      <ManufacturabilityScore score={a.manufacturability_score}/>
      <IndustrialMetrics metrics={a.industrial_metrics} productionRisks={a.production_risks}/>
    </div>
  );
}

export function MachineTab({ a }) {
  const { t } = useTranslation();
  return (
    <div className="space-y-5" data-testid="machine-tab">
      <SuggestedMachine suggested={a.suggested_machine}/>
      {a.alternative_methods?.length > 0 && (
        <div className="tech-card p-5" data-testid="alt-methods">
          <div className="flex items-center gap-2 mb-3 text-blue-400">
            <Sparkles size={16}/> <div className="label-tech text-blue-400">{t("quoteTabs.altMethodsProduction")}</div>
          </div>
          <ul className="space-y-2 text-sm text-slate-300">
            {a.alternative_methods.map((m, i) => <li key={`alt-${i}-${(m || "").slice(0, 10)}`} className="flex gap-2"><span className="text-blue-400">→</span> {m}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
